import { Typography, TypographyProps } from "@mui/material";

export default function NaoInformado({ children, ...props }: TypographyProps) {
  return (
    <Typography color="text.disabled" fontStyle="italic" fontSize=".8rem" {...props}>
      {children ?? "(não informado)"}
    </Typography>
  );
}
